/* @ngInject */
function TaskTagsInputController ($scope, $timeout, Utils, TaskTagsService, SegmentService) {
  $scope.allTags = []
  $scope.tagsCount = null
  $scope.suggestedTags = []
  $scope.inputValue = []
  $scope.showSuggestions = false

  const pagination = {
    top: 10,
    index: 0
  }

  let search = ''
  const charLimit = 15

  const api = {
    _getTaskTags,
    _getTaskTagsSuggestions,
    _formatTags,
    _saveTags,
    _removeSuggestedTag,
    _showSuggestions
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getTaskTags()

    $timeout(() => {
      api._showSuggestions($scope.task?.tags)
    }, 100)
  }

  const deregisterTaskTagsWatcher = $scope.$watch('task.tags', (newValue) => {
    if (!newValue) return

    if (!$scope.new && !$scope.suggestedTags) {
      api._getTaskTagsSuggestions()
    }

    $timeout(() => {
      $scope.inputValue = [...newValue].map(tag => Utils.truncateText(tag, charLimit))

      api._showSuggestions(newValue)
    })
  })

  $scope.onInfiniteTags = () => {
    pagination.index++
    api._getTaskTags()
  }

  $scope.onSearchTags = (event) => {
    const searchTerm = event.detail?.search || ''
    pagination.index = search !== searchTerm ? 0 : pagination.index++
    search = searchTerm

    api._getTaskTags()
  }

  $scope.onChangeTags = (event) => {
    /**
     * Track new tags selected.
     */
    if (event.detail?.length) {
      const currentTagsIds = $scope.task.tags?.map(tag => tag.id)
      const newTags = event.detail.filter(tag => !currentTagsIds?.includes(tag.id))
      if (newTags?.length) {
        for (const tag of newTags) {
          SegmentService.track('workflow-tag-add', {
            tag_name: tag.label
          })
        }
      }
    }

    $scope.task.tags = event.detail.map(tag => Utils.truncateText(tag, charLimit))
    api._showSuggestions($scope.task.tags)
    if ($scope.autoSave) {
      api._saveTags()
    }
  }

  $scope.onCreateTag = (event) => {
    const label = event.detail.option
    if (!label) return

    TaskTagsService.createTaskTag(label).then(tag => {
      const tagObj = {
        value: tag.id,
        label: Utils.truncateText(tag.label, charLimit),
        color: tag.color
      }

      if (!$scope.task.tags) $scope.task.tags = []

      $scope.task.tags.push(tagObj)
      $timeout(() => {
        const newTags = [...$scope.inputValue, tagObj]
        $scope.inputValue = newTags
      })

      if ($scope.autoSave) {
        api._saveTags()
      }

      SegmentService.track('workflow-tag-add', {
        tag_name: tag.label
      })
    })
  }

  $scope.onTagPillClick = (tag) => {
    if (!$scope.task.tags) $scope.task.tags = []
    const index = $scope.task.tags.findIndex(item => item.value === tag.value)

    SegmentService.track('workflow-tag-add', {
      tag_name: tag.label
    })

    if (index === -1) {
      $timeout(() => {
        const newTags = [...$scope.inputValue, Utils.truncateText(tag, charLimit)]
        $scope.inputValue = newTags
      })

      $scope.task.tags.push(tag)
      if ($scope.autoSave) {
        api._saveTags()
      }
    }

    api._removeSuggestedTag(tag)
  }

  $scope.onLastTag = () => {
    $timeout(() => {
      $('uds-pill.tag-tooltip').popup({
        hoverable: true,
        position: 'top center',
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 100)
  }

  function _getTaskTags () {
    TaskTagsService.getTaskTags({ top: pagination.top, skip: pagination.top * pagination.index, search }).then(tags => {
      const allTags = api._formatTags(tags.rows)
      $scope.allTags = [...allTags]
      $scope.tagsCount = tags.count
    })
  }

  function _getTaskTagsSuggestions () {
    let tagIds = null
    if ($scope.task?.tags) {
      tagIds = $scope.task.tags.map(item => {
        if (typeof item === 'number') return item
        return item.value || item.id
      })
    }

    TaskTagsService.getTaskTagsSuggestions(tagIds).then(tags => {
      $scope.suggestedTags = api._formatTags(tags)
    })
  }

  function _formatTags (tags) {
    const formattedTags = tags.map(tag => {
      return {
        id: tag.id,
        value: tag.id,
        label: tag.label,
        truncatedLabel: Utils.truncateText(tag.label, charLimit),
        color: tag.color
      }
    })

    return formattedTags
  }

  function _saveTags () {
    if (!$scope.task.id) return
    const tags = $scope.task.tags.map(tag => tag.value)
    TaskTagsService.updateTaskTagsById($scope.task.id, tags)
  }

  function _removeSuggestedTag (tag) {
    const index = $scope.suggestedTags.findIndex(item => item.value === tag.value)
    if (index === -1) return

    $scope.suggestedTags.splice(index, 1)
  }

  function _showSuggestions (tags) {
    if (tags?.length && !$scope.new) {
      $scope.showSuggestions = false
      return
    }

    $scope.showSuggestions = true
    api._getTaskTagsSuggestions()
  }

  $scope.$on('$destroy', () => {
    deregisterTaskTagsWatcher()
  })
}

export { TaskTagsInputController }
